"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { cn } from "@/utils/cn";
import { ImageGalleryCategory, ImageGalleryImage, useImageGallery } from "..";
interface GalleryCategoriesProps {
  categories: ImageGalleryCategory[];
  className?: string;
  selectedCategory?: ImageGalleryCategory;
  onCategoryChange?: (category: ImageGalleryCategory) => void;
}
export function GalleryCategories(t0) {
  const $ = _c(25);
  const {
    categories,
    className,
    selectedCategory,
    onCategoryChange
  } = t0;
  const {
    images,
    goToIndex
  } = useImageGallery();
  if (!categories || categories.length === 0) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== categories || $[1] !== className || $[2] !== goToIndex || $[3] !== images || $[4] !== onCategoryChange || $[5] !== selectedCategory?.code) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t5;
      if ($[10] !== images) {
        t5 = category => images.some(image => image.space === category.code);
        $[10] = images;
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      const availableCategories = categories.filter(t5);
      if (availableCategories.length === 0) {
        t4 = null;
        break bb0;
      }
      if ($[12] !== className) {
        t3 = cn("absolute bottom-0 left-0 w-full z-30", className);
        $[12] = className;
        $[13] = t3;
      } else {
        t3 = $[13];
      }
      t1 = "flex gap-2 overflow-x-auto max-w-full px-3 py-2 bg-gradient-to-t from-black/90 to-black/0 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-white/20 hover:scrollbar-thumb-white/40";
      let t6;
      if ($[14] !== goToIndex || $[15] !== images || $[16] !== onCategoryChange || $[17] !== selectedCategory?.code) {
        t6 = (category_0, index) => {
          const imageCount = images.filter(image_0 => image_0.space === category_0.code).length;
          const isSelected = selectedCategory?.code === category_0.code;
          return <Button key={`${category_0.code}-${index}`} data-category={category_0.code} onClick={() => {
            const categoryIndex = images.findIndex(image_1 => image_1.space === category_0.code);
            if (categoryIndex !== -1) {
              goToIndex(categoryIndex);
              onCategoryChange?.(category_0);
            }
          }} variant="link" className={cn("relative px-2 py-1 text-sm transition-all duration-200 focus:outline-none after:bg-white", isSelected ? "text-white font-medium after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:shadow-sm after:opacity-100" : "text-white/80 hover:text-white")}><span>{category_0.name.includes(":") ? category_0.name.split(":")[1] : category_0.name}</span><span className={cn("ml-1 rounded-full px-1 text-xs font-bold", isSelected ? "bg-white/40 text-white" : "bg-white/30 text-white/90")}>{imageCount}</span></Button>;
        };
        $[14] = goToIndex;
        $[15] = images;
        $[16] = onCategoryChange;
        $[17] = selectedCategory?.code;
        $[18] = t6;
      } else {
        t6 = $[18];
      }
      t2 = availableCategories.map(t6);
    }
    $[0] = categories;
    $[1] = className;
    $[2] = goToIndex;
    $[3] = images;
    $[4] = onCategoryChange;
    $[5] = selectedCategory?.code;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[19] !== t1 || $[20] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t3 || $[23] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}